export const SIDEBAR_STATE_STORAGE_KEY = 'sidebar_state';
